<template>
  <v-card width="100%">
    <template>
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        top
        color="deep-purple accent-4"
      ></v-progress-linear>
    </template>
    <v-card-title>
      Unit Accounts
      <v-spacer></v-spacer>
      <div class="tableSearch mr10px">
        <v-text-field
          v-model="search"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          single-line
          filled
          rounded
          dense
          hide-details
        ></v-text-field>
      </div>
    </v-card-title>
  <!--  <table border>
      <tr>
        <td>All</td>
      </tr>
      <template v-for="(obj, index) of arrAccounts">
        <tr :key="index">
           <td>
          {{ index+1}}
          </td>
       
          <td>
            <v-btn @click="showTransactions(obj.UnitAccountID)">
              {{obj.AccountNumberNineDigit}}
            </v-btn>
          </td>
        </tr>
      </template>
    </table>
-->

<v-tabs
      v-model="tab"
      background-color=""
      class="elevation-2"
      dark
   
      
      :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
      :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
      :icons-and-text="icons"
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab
        v-for="(obj, index) of arrAccounts"
        :key="index"
       @click="showTransactions(obj.UnitAccountID)"
      > <v-icon>mdi-book</v-icon>
        Account {{obj.AccountNumberNineDigit}}
    

       
      </v-tab>

    
    </v-tabs>



    <v-data-table :headers="headers" :items="arrTransactions" :search="search">
      <template v-slot:item.transactions="{ item }"> </template>
    </v-data-table>
  </v-card>
</template>

<script>
import api from "@/api";
export default {
  props: ["id"],
  data() {
    return {
      search: "",
      headers: [
       
        {
          text: "Date",
          align: "left",
          sortable: true,
          value: "PostingDate",
        },
        {
          text: "Description",
          align: "left",
          sortable: true,
          value: "Description",
        },{
          text: "Amount",
          align: "left",
          sortable: true,
          value: "Amount",
        },
        {
          text: "Balance",
          align: "left",
          sortable: true,
          value: "Balance",
        },{
          text: "TAcctID",
          align: "left",
          sortable: true,
          value: "TAcctID",
        },
      ],
      loading: true,
      arrItems: [],
      arrAccounts: [],
      arrTransactions:[],
      model: {},
      dialog: false,
    };
  },
  async created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      //console.log("inside refersf");
      this.loading = true;
      var intUnitId = this.id;
      this.arrAccounts = await api.getUnitAccounts(intUnitId);
      if(this.arrAccounts.length>0){
        var obj1stAccount = this.arrAccounts[0];
        this.arrTransactions = obj1stAccount.arrTransactions;
      }
      //this.arrItems = this.objModel.arrLevels;
      console.log("inside refersf");
      this.loading = false;
    },
    async populatePostToEdit(post) {
      this.model = Object.assign({}, post);
    },
    async savePost() {
      if (this.model.id) {
        await api.updatePost(this.model.id, this.model);
      } else {
        await api.createPost(this.model);
      }
      this.model = {}; // reset form
      await this.refresh();
    },
    async deletePost(id) {
      if (confirm("Are you sure you want to delete this post?")) {
        // if we are editing a post we deleted, remove it from the form
        if (this.model.id === id) {
          this.model = {};
        }
        await api.deletePost(id);
        await this.refresh();
      }
    },
    async  showTransactions(intAccountId){
        this.loading = true;
        this.arrTransactions = await api.getUnitAccountTransactions(intAccountId);
        this.loading = false;
    }
  },
};
</script>
